import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsFhe(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsFhe(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsFhe - ', e);
                throw e;
            });
    };
}
export { getLogsFhe };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsFhe/actions.js